import React from 'react';
import './Shop.css'
import { Helmet } from 'react-helmet';

function Code() {
  return <div className='shop'>
    <Helmet>
      <title>Aadhaar Koul | Code</title>
    </Helmet>
      <div className='shop-container'>
        <div className='top-scroll'></div>
        <div className='top-nav'>
          <a href='/shop'><div>Assets</div></a>
          <a href='/shoproject'><div>Projects</div></a>
          <a href='/code'><div className='current-tab'>IOT</div></a>
          <a href='/research'><div>Research</div></a>
          <a href='/books'><div>Books</div></a>
        </div>
        <div className='banner'>
          <h2>Coming Soon</h2>
          <p>This feature is currently under development. You'll be able to access it as soon as it goes live. In the meantime, feel free to explore other catalogs in our online store. Click on 'Notify Me' to receive updates the moment this feature becomes available.
          </p>
          <div>
          <button>Notify Me</button>
          </div>
        </div>
      </div>
    </div>;
}

export default Code;
